import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

import DefaultValuesUtils from "../utils/classes/DefaultValuesUtils";

import { useGlobalRegisters } from "../context/GlobalRegisters/GlobalRegistersContext";

const Route = ({ component: Component, isPrivate = false, isRestricted = false, ...rest }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { isAuth, loading } = useContext(AuthContext);
  const { setAreThereQueueOverrideRequests } = useGlobalRegisters();

  //  *****************
  //  ** Redirectors **
  //  *****************
  if (!isAuth && isPrivate) {
    setAreThereQueueOverrideRequests(false);
    localStorage.setItem("selectedIndexRoute", 0);
    
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: DefaultValuesUtils.ROUTES[102], state: { from: rest.location } }} />
      </>
    );
  }

  if (isAuth && isRestricted) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
      </>
    );
  }

  //  ************
  //  ** Return **
  //  ************
  return (
    <>
      {loading && <BackdropLoading />}
      <RouterRoute {...rest} component={Component} />
    </>
  );
};

export default Route;
